import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { Venue } from "../../../model/Venue";

export const GET_VENUE_FOR_EDIT_SUCCESS = "GET_VENUE_FOR_EDIT_SUCCESS";

export interface GetVenueForEditSuccessAction extends Action {
  type: typeof GET_VENUE_FOR_EDIT_SUCCESS;
  venue: Venue;
  organization: OrganizationKeyName;
}

export const getVenueForEditSuccessAction = (
  organization: OrganizationKeyName,
  venue: Venue
): GetVenueForEditSuccessAction => ({
  type: GET_VENUE_FOR_EDIT_SUCCESS,
  venue,
  organization,
});
